import { Placement, Side } from "@floating-ui/react";
import { DEFAULT_PLACEMENT_SIDE } from "./constants";

const ARROW_PLACEMENT_CONFIG = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right",
};

export const getArrowPlacementSide = (placement: Placement) => {
  const [placementSide] = placement.split("-") as Side[];

  return ARROW_PLACEMENT_CONFIG[placementSide] || DEFAULT_PLACEMENT_SIDE;
};
